/**
 * Holds the different types of conditions for sternum queries.
 */
enum AuthenticationType {
    MFA = "MFA",
}

export default AuthenticationType;
